import { FormlyFieldConfig } from '@ngx-formly/core';
import {
  sharedTipHintConsultation2026,
  sharedTipHintNoresident2026,
  sharedTipHintNoresidentTaxDomicile2026,
  sharedTipHintResident2026,
} from './complete-form';
import { OnlyTaxDeclarationForm2026 } from './summary-common.form';

export const employeeFormTaxDeclaration2026 = (
  personalData: boolean
): FormlyFieldConfig[] => [
    {
      key: 'taxDeclaration',
      expressionProperties: {
        // className: () => (!personalData ? 'p-col-12' : 'none'),
      },
      fieldGroup: [
        // {
        //   type: 'h2',
        //   props: {
        //     translate: true,
        //     // prefix: '3. ',
        //     label: 'TPA.Residenture',
        //   },
        // },

        {
          type: 'rezidentura-2026',
          key: 'rezidentura',
          props: {
            translate: true,
            label: 'TPA.ResidentureRecognition',
          },
        },

        sharedTipHintResident2026(),
        sharedTipHintNoresident2026(),
        sharedTipHintConsultation2026(),
        sharedTipHintNoresidentTaxDomicile2026(),
        {
          wrappers: ['panel-wrapper-pink'],
          className: 'p-col-12',
          props: {},
          key: 'taxDeclaration',
          fieldGroup: [...OnlyTaxDeclarationForm2026()],
        },
      ],
    },
  ];
